(function(){
    'use strict'

    angular
    .module('app.turnos')
    .controller('Turnos', Turnos);

    Turnos.$inject = ['$animationsSrv', 'TurnosService', 'logger', '$location', 'UserInfoService'];

    function Turnos($animationsSrv, TurnosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.turnos = [];
        vm.title = 'Turnos';

        vm.goToEdit = function(turno){
            
            var path = '/editar-turno/';

            if(turno){
                $location.path(path + turno.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = TurnosService.getAll();

            promise
            .then(function(turnos){
                vm.turnos = turnos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los turnos.');
                        break;
                }
            });
        };

        vm.delete = function(turno){
            var promise = TurnosService.remove(turno);
            
            promise
            .then(function(response){
                vm.turnos = vm.turnos.filter(function(g) {
                    return g.id !== turno.id;
                });
                logger.success('Turno eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Turno');
                        break;
                }
                
            });   
        };

    }
})();